<template>
    <v-main>
        <AppBar @click="close()"/>
        <v-layout fill-height column id="1">
            <v-container flex-fill fluid>
                <v-form class="form-item" v-model="valid">
                    <label class="label">수령인</label>
                    <div class="input-group">
                        <v-text-field solo flat filled
                            v-model="po.recipient"
                            required
                            placeholder="이름"
                        />
                    </div>
                    <label class="label">휴대전화</label>
                    <div class="input-group">
                        <v-text-field solo flat filled
                            v-model="po.phoneNum"
                            required
                            placeholder="01000000000"
                        />
                    </div>
                    <label class="label">배송지 주소</label>
                    <div class="input-group mb-3">
                        <v-text-field solo flat filled
                                hide-details="true"
                                v-model="po.addressFirst"
                                required
                                placeholder="주소를 검색해 주세요"
                        />
                        <v-btn elevation="0" :ripple="false" color="black" width="90" height="48"
                            class="fs-14 white--text ml-2" @click="showApi">주소검색</v-btn>
                    </div>
                    <div class="input-group">
                        <v-text-field solo flat filled
                            v-model="po.addressSecond"
                            required
                            placeholder="상세 주소를 입력해 주세요"
                        />
                    </div>
                    <label class="label">공동현관 출입방법</label>
                    <div class="input-group">
                        <v-text-field append-icon="mdi-menu-down" solo flat filled v-model="po.enterMethodCd" readonly
                        placeholder="공동현관 출입방법을 선택해주세요" @click="rollerPickerOpen" />
                    </div>
                    <v-textarea
                        filled
                        solo
                        flat
                        background-color="#F7F7F7"
                        no-resize
                        placeholder="특수문자, 기호등을 포함해 비밀번호를 정확히 입력해주세요."
                        class="pa-0 textarea"
                        style="margin-top: -18px;"
                        hide-details="true"
                        v-model="po.enterMemo"
                        v-if="po.enterMethodCd === '기타'"
                    ></v-textarea>
                    <div v-if="po.requestCd === '기타'" class="info--text fs-12 mt-2 mb-6">비밀번호가 정확하지 않을 경우 공동 현관 혹은 경비실 앞에 배송 될 수 있습니다.</div>
                    <label class="label">배송시 요청사항</label>
                    <div class="input-group">
                        <v-text-field solo flat filled v-model="po.requestCd" readonly
                            placeholder="요청사항을 선택해주세요" @click="rollerPickerOpen2" />
                    </div>
                    <v-textarea
                        filled
                        solo
                        flat
                        background-color="#F7F7F7"
                        no-resize
                        placeholder="내용을 입력해주세요."
                        class="pa-0 textarea"
                        style="margin-top: -18px;"
                        v-model="po.requestMemo"
                        v-if="po.requestCd === '기타'"
                    ></v-textarea>
                </v-form>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="등록하기" :disabled="false" @click="register"/>
            </div>
        </v-layout>
        <SelectRollerPicker ref="rollerPicker" @selectValue="selectValue" />
        <DaumKakaoAddressModal ref="DaumKakaoAddressModal" :kakaoDialog="searchSheet" @close="searchModalClose"/>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import SelectRollerPicker from "@/components/layout/bottomSheet/SelectRollerPicker";
import store from '@/store'
import DaumKakaoAddressModal from "../../components/layout/DaumKakaoAddressModal.vue";

export default {
    data: () => ({
        props:{
            daNo:{
                type:Number
            }
        },
        valid: false,
        po:{
            recipient: '',
            phoneNum: '',
            addressFirst: '',
            addressSecond: '',
            enterMethodCd: '',
            enterMemo: '',
            requestCd: '',
            requestMemo: ''
        },
        items: ['선택','부재중시 경비실에 맡겨주세요','기타'],

        items2: ['선택', '현관 앞에 놓아 주세요.', '부재시 경비실에 맡겨 주세요.', '무인 택배함에 넣어주세요.', '부재시 휴대 전화로 연락주세요.', '기타'],
        searchSheet:false

    }),
    components: {
    BlackBtn,
    SelectRollerPicker,
    DaumKakaoAddressModal
    },
    created(){

    }
    ,
    methods: {
        searchModalClose(){
            this.searchSheet = false;
        },
        async register(){
            await store.dispatch('deliveryAddress', this.$_payload('po', this.po))
            .then(res => {
                console.log(res)
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
        rollerPickerOpen(){
            this.selectFlag = 1;
            this.$refs.rollerPicker.setFlicking(this.items);
        },
        rollerPickerOpen2(){
            this.selectFlag = 2;
            this.$refs.rollerPicker.setFlicking(this.items2);
        },
        selectValue (value){
            this.$nextTick(() => {
                if(this.selectFlag === 1) {
                this.po.enterMethodCd = value;
                }else {
                    this.po.requestCd = value;
                }
                this.selectFlag = 0;
            })

        },
        showApi() {
            this.searchSheet=true;
        },
        daumClose(){
            alert("gggg");
        }
    }
}
</script>
<style lang="scss" scoped>
.textarea::v-deep {
    textarea::placeholder  {
      font-size: 14px;
    }
}
</style>
